import { useLocation } from 'react-router-dom';
import { useUserStore } from '../../modules/Auth/stores/authStore';
import { canInteractOnRoute, isFreemiumContent } from './freemium';

/**
 * Hook central de acesso freemium. Use no lugar de espalhar
 * `user?.isFreemium && !item.freemium` pelos componentes.
 *
 * - `isFreemium`: usuário é do plano freemium.
 * - `isReadOnly`: está numa rota onde o freemium só pode visualizar.
 * - `isContentLocked(item)`: conteúdo de disciplina bloqueado (freemium sem tag).
 * - `isFreemiumUnlocked(item)`: conteúdo liberado exclusivamente para o freemium.
 */
export function useAccess() {
  const { user } = useUserStore();
  const { pathname } = useLocation();
  const isFreemium = !!user?.isFreemium;
  const canInteract = canInteractOnRoute(pathname);

  return {
    isFreemium,
    isReadOnly: isFreemium && !canInteract,
    // O bloqueio de conteúdo só existe dentro de /disciplinas. Fora dali o
    // freemium apenas visualiza (mutações são barradas pelo interceptor).
    isContentLocked: (item?: { freemium?: boolean }) =>
      isFreemium && canInteract && !isFreemiumContent(item),
    // Conteúdo liberado só faz sentido destacar para o próprio freemium: para
    // os demais planos tudo já está disponível, então não há o que sinalizar.
    isFreemiumUnlocked: (item?: { freemium?: boolean }) =>
      isFreemium && canInteract && isFreemiumContent(item),
  };
}
